<template>
  <div class="hello" style="background-color: #E8E8E8; min-height: 100vh;">
    <div
      style="color: #51A6FF; font-size: 18px; font-weight: 600;text-align: left; padding: 10px 10px;"
    >
      {{ projectdetail.xmmc }}
    </div>
    <div style="padding: 10px 10px;">
      <form action="/">
        <van-search
          v-model="value"
          placeholder="请输入搜索关键词"
          @search="onSearch"
          @clear="onClear"
        />
      </form>
      <van-row
        type="flex"
        justify="space-around"
        style="margin-top: 10px; padding: 0px 0px;border-radius: 4px;"
      >
        <van-col span="6">
          <van-tag
            round
            color="rgb(46, 204, 190)"
            :plain="currentZt == 2"
            style="text-align:center;font-size: 10px; padding: 2px 12px;"
            @click="filterClick(2)"
            >正常({{ counts[0] }})</van-tag
          >
        </van-col>
        <van-col span="6">
          <van-tag
            round
            color="rgb(86, 170, 255)"
            :plain="currentZt == 3"
            style="text-align:center;font-size: 10px; padding: 2px 12px;"
            @click="filterClick(3)"
            >超前({{ counts[1] }})</van-tag
          >
        </van-col>
        <van-col span="6">
          <van-tag
            round
            color="rgb(243, 115, 68)"
            :plain="currentZt == 1"
            style="text-align:center;font-size: 10px; padding: 2px 12px;"
            @click="filterClick(1)"
            >滞后({{ counts[2] }})</van-tag
          >
        </van-col>
        <van-col span="6">
          <van-tag
            color="rgb(150, 150, 150)"
            :plain="currentZt == 4"
            round
            style="text-align:center;font-size: 10px; padding: 2px 12px;"
            @click="filterClick(4)"
            >办结({{ counts[3] }})</van-tag
          >
        </van-col>
      </van-row>
      <div
        style="background-color: #fff; margin-top: 10px; padding: 10px 0px;border-radius: 4px;"
      >
        <van-collapse
          v-if="subproject.length > 0"
          v-model="activeNames"
          accordion
        >
          <van-collapse-item
            :name="index"
            v-for="(item, index) in subproject"
            :key="index"
          >
            <div slot="title" style="text-align: left; color:#000">
              {{ item.name }}
            </div>
            <div @click="clickMethod(item.projectId)">
              <van-row
                type="flex"
                justify="space-between"
                style="margin: 0px 0px;flex-wrap: wrap;"
              >
                <van-col span="24" style="text-align: left;"
                  >分管区领导：{{ item.fgqld.toString() }}</van-col
                >
                <van-col span="24" style="text-align: left;"
                  >牵头单位：{{ item.qtdw }}</van-col
                >
                <van-col span="24" style="text-align: left;"
                  >协同单位：{{ item.xtdw.toString() }}</van-col
                >
                <!-- <van-col span="24" style="text-align: left;">责任人：{{item.zrr.toString()}}</van-col> -->
              </van-row>
            </div>
          </van-collapse-item>
        </van-collapse>
        <div v-else>当前无记录</div>
      </div>
      <div
        v-if="ifOwner == 1 || ifOwner == 2"
        style="margin-top: 10px; background-color: #fff; padding: 10px 10px;border-radius: 4px;"
      >
        <van-cell-group>
          <van-field
            v-model="message"
            type="textarea"
            placeholder="请输入留言"
            rows="2"
            autosize
          />
        </van-cell-group>
        <div style="text-align: center; margin-top: 20px; margin-left: 10px;">
          <van-tag
            v-if="ifOwner == 2"
            color="#0959E4"
            style="padding: 4px 40px;"
            @click="psMethod()"
            :loading="buttonLoading"
            >批示</van-tag
          >
          <van-tag
            v-else
            color="#0959E4"
            style="padding: 4px 40px;"
            @click="psMethod()"
            :loading="buttonLoading"
            >发送</van-tag
          >
        </div>
        <van-steps
          direction="vertical"
          :active="0"
          active-color="#969799"
          active-icon="circle"
          style="margin-top: 40px;"
        >
          <van-step v-for="(item6, index6) in messageList" :key="index6 + '-6'">
            <van-row
              type="flex"
              style="text-align: left; font-size: 14px; color: #000; padding: 0px 10px 0px 10px;flex-wrap: wrap;"
            >
              <van-col span="10" style="font-size: 14px; font-weight: 600;">{{
                item6.psryXm
              }}</van-col>
              <van-col span="14" style="font-size: 14px; font-weight: 200;">{{
                parseTime(item6.createTime)
              }}</van-col>
              <van-col
                span="24"
                style="font-size: 14px; font-weight: 200; padding-top: 10px;"
                >{{ item6.psnr }}</van-col
              >
            </van-row>
          </van-step>
        </van-steps>
      </div>
      <div style="height: 100px;"></div>
    </div>
  </div>
</template>

<script>
import zdqdUser from '../api/zdqd'
import { Toast } from 'vant'
import { parseTime } from '../utils/index'
export default {
  name: 'Zdqd',
  data () {
    return {
      chart: null,
      value: '',
      activeNames: '',
      subproject: [],
      initSubproject: [],
      counts: [0,0,0,0],
      projectdetail:{},
      message: '',
      messageList: [],
      ifOwner: 0,
      buttonLoading: true,
      currentZt: 0
    }
  },
 async created () {
    if(this.$route.query.isAll) {
        this.projectdetail.xmmc = '总体进度'
        const cysj = await zdqdUser.getProjectListByZt(1, this.$route.query.selectYear)
        const xmts = await zdqdUser.getProjectListByZt(2, this.$route.query.selectYear)
        const ggcx = await zdqdUser.getProjectListByZt(3, this.$route.query.selectYear)
        const gfxx = await zdqdUser.getProjectListByZt(4, this.$route.query.selectYear)
        const zlpn = await zdqdUser.getProjectListByZt(5, this.$route.query.selectYear)
        const djyl = await zdqdUser.getProjectListByZt(6, this.$route.query.selectYear)
        const listAll = {}
        listAll.counts = []
        cysj.data.counts.forEach((x,i) => {
          listAll.counts.push(cysj.data.counts[i] + xmts.data.counts[i] + ggcx.data.counts[i] + gfxx.data.counts[i] + zlpn.data.counts[i] + djyl.data.counts[i])
        })
        listAll.subproject = [...cysj.data.subproject,...xmts.data.subproject,...ggcx.data.subproject,...gfxx.data.subproject,...zlpn.data.subproject,...djyl.data.subproject]
        this.initSubproject = listAll.subproject
        this.counts = listAll.counts
        this.ifOwner = 0
        this.filterClick(this.$route.query.zt)
    }else if (this.$route.query.type) {
        this.projectdetail.xmmc = this.$route.query.name
        zdqdUser.getProjectListByZt(this.$route.query.type, this.$route.query.selectYear).then(res => {
        this.initSubproject = res.data.subproject
        this.counts = res.data.counts
        this.ifOwner = 0
        this.filterClick(this.$route.query.zt)
      })
    } else if (this.$route.query.id) {
      zdqdUser.getTotalProjectsDetail(this.$route.query.id).then(async res => {
        const res2 = await zdqdUser.DetailListEeplace(res.data.subproject)
       this.subproject = res2.data
      //  this.subproject = res.data.subproject
        this.initSubproject = res.data.subproject
        this.counts = res.data.counts
        this.projectdetail = res.data.projectdetail
        this.ifOwner = res.data.ifOwner

      })
      zdqdUser.getPs(this.$route.query.id).then(res1 => {
          this.messageList = res1.data
      })
    }
  },
  methods: {
    parseTime,
    clickMethod(id){
      this.$router.push({  //核心语句
        path: '/projectdetail',   //跳转的路径
        query:{id:id}
      })
    },
    onSearch(){
      this.currentZt = 0
      if(this.value == ''){
        this.subproject = this.initSubproject
      } else {
        this.subproject = this.initSubproject.filter(item => {
          return item.name.indexOf(this.value) > -1
        })
      }
    },
    onClear(){
      this.subproject = this.initSubproject
    },
    filterClick(key){
      this.value = ''
      if (this.currentZt == key) {
        this.currentZt = 0
        this.subproject = this.initSubproject
      } else {
        this.currentZt = key
        this.subproject = this.initSubproject.filter(item => {
          return item.zt == key
        })
      }
    },
    psMethod(){
      if(this.message == ''){
        Toast.fail('批示信息不能为空！')
      } else {
        this.buttonLoading = false
        var params = {
          projectId: this.$route.query.id,
          psnr: this.message
        }
        zdqdUser.psMethod(params).then(res => {
          zdqdUser.getPs(this.$route.query.id).then(res1 => {
            this.messageList = res1.data
          })
          Toast.success('批示成功！')
          this.message = ''
          this.buttonLoading = true
        })
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.van-cell.van-field {
  background-color: #e8e8e8;
  border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/ProjectList.vue